<template>
  <div id="app">
    <ChungChup />
  </div>
</template>

<script>
import ChungChup from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    ChungChup
  }
}
</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Gowun+Batang:wght@400;700&family=Nanum+Brush+Script&family=Nanum+Gothic&display=swap');

#app {
  font-family: 'Gowun Batang', serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  touch-action: pan-y !important;
}

.vm--overlay {
  touch-action: pan-y !important;
}
</style>
